import { MAX_ITEMS_IN_PAGE } from "../../actions/commonActions";

const initState = {
  dailyTasks: [],
  dailyTask: [],
  projectOptions: [],
  taskOptions: [],
  selectedWeek: {},
  numRows: 1,
  taskDates: [],
  taskDate: "",
  teamDailyTask: [],
  taskEntries: [
    {
      remarks: "",
      reason: "",
      action: "Pending",
      project_id: "",
      task_id: "",
      actual_time: "",
      end_time: "",
      start_time: "",
      actual_transaction: "",
      project_name: "",
      task_name: "",
      entry_id: 0,
    },
  ],
  taskEntry: {},
  totalActualTime: 0,
  durationEntries: [],
  entryIdsToDelete: [],
  monthlyEntries: [],
  taskLoader: false,
  entriesByProject: {},
  overTimeEntries: [],
  timeEntriesPerProject: [], //group per band
  approvedTimeEntries: [],
  currentPage: 1,
  totalPages: 0,
  numItems: 0,
  min: 1,
  max: MAX_ITEMS_IN_PAGE,
};

const taskReducer = (state = initState, action) => {
  switch (action.type) {
    case "TASK_SET_FIELD_VALUE":
      return {
        ...state,
        task: Object.assign(state.task, action.value),
      };
    case "FETCH_TASKS":
      return {
        ...state,
        tasks: action.tasks,
      };
    case "FETCH_DAILY_TASK_ENTRY":
      return {
        ...state,
        taskEntry: action.taskEntry,
      };
    case "FETCH_TEAM_DAILY_TASK_ENTRY":
      return {
        ...state,
        teamDailyTask: action.teamDailyTask,
      };
    case "FETCH_DAILY_TASKS":
      return {
        ...state,
        dailyTasks: action.tasks,
      };
    case "FETCH_DAILY_TASK":
      return {
        ...state,
        dailyTask: action.task,
      };
    case "FETCH_PROJECT_TASK_OPTION":
      return {
        ...state,
        projectTaskOptions: action.projectTask,
      };
    case "SET_TASK_DATE":
      return {
        ...state,
        taskDate: action.taskDate,
      };
    case "ASSIGN_PROJECT_TASK_OPTION":
      return {
        ...state,
        projectOptions: action.projectOptions,
        taskOptions: action.taskOptions,
      };
    case "SET_SELECTED_WEEK":
      return {
        ...state,
        selectedWeek: action.week,
      };
    case "ADD_DATES":
      return {
        ...state,
        taskDates: [...state.taskDates, action.value],
      };
    case "SET_TASK":
      return {
        ...state,
        task: action.task,
      };
    case "RESET_TASK":
      return {
        ...state,
        daily_tasks: [],
      };
    case "RESET_TASK_ENTRIES":
      return {
        ...state,
        taskEntries: [
          {
            entry_id: 1,
            project_id: 0,
            task_id: 0,
          },
        ],
        numRows: 1,
        durationEntries: [],
        taskDates: [],
        selectedWeek: {},
      };
    case "CLEAR_TASK_ENTRIES":
      return {
        ...state,
        taskEntries: [],
      };
    case "UPDATE_TASK_ENTRIES":
      return {
        ...state,
        taskEntries: action.taskEntries,
      };
    case "UPDATE_TASK_ENTRIES_TOTAL_TIME":
      return {
        ...state,
        totalActualTime: action.totalActualTime,
      };
    case "UPDATE_TASK_ENTRY":
      return {
        ...state,
        taskEntries: state.taskEntries.map((taskEntry) =>
          taskEntry.entry_id === action.entry_id
            ? action.updatedTaskEntry
            : taskEntry
        ),
      };
    case "ADD_DAILY_TASK_ENTRY":
      return {
        ...state,
        taskEntries: state.taskEntries.map((taskEntry) =>
          taskEntry.entry_id === action.entry_id
            ? { ...taskEntry, [action.id]: action.value }
            : taskEntry
        ),
      };
    case "ADD_TASK_ENTRY_DATE":
      return {
        ...state,
        durationEntries: [...state.durationEntries, action.entry],
      };
    case "SHOW_TASK_LOADER":
      return {
        ...state,
        taskLoader: action.show,
      };
    case "UPDATE_TASK_DURATIONS":
      return {
        ...state,
        durationEntries: action.newDurations,
      };
    case "ADD_TASK_ROW_NUM":
      return {
        ...state,
        numRows: state.numRows + 1,
        taskEntries: [
          ...state.taskEntries,
          { entry_id: state.numRows + 1, project_id: 0, task_id: 0 },
        ],
      };
    case "DECREASE_TASK_NUM_ROW":
      return {
        ...state,
        numRows: state.numRows - 1,
      };
    case "SET_TASK_ROW_NUM":
      return {
        ...state,
        numRows: action.rowNum,
      };
    case "ADD_TASK_REMARKS":
      return {
        ...state,
        task: Object.assign(state.task, action.remarks),
      };
    case "DELETE_TASK_ENTRY":
      const newTaskEntries = state.taskEntries.filter((object) => {
        return object.entry_id !== action.entryId;
      });
      return {
        ...state,
        taskEntries: newTaskEntries,
      };
    case "CLEAR_ENTRY_TO_DELETE":
      return {
        ...state,
        entryIdsToDelete: [],
      };
    case "SET_MONTHLY_ENTRIES":
      return {
        ...state,
        monthlyEntries: action.monthlyEntries,
      };
    case "RESET_MONTHLY_ENTRIES":
      return {
        ...state,
        monthlyEntries: [],
      };
    case "GET_ENTRIES_BY_PROJECT_ID":
      return {
        ...state,
        entriesByProject: Object.assign(state.entriesByProject, {
          [action.projectId]: action.newEntries,
        }),
      };
    case "ADD_OVERTIME_ENTRIES":
      return {
        ...state,
        overTimeEntries: [
          ...state.overTimeEntries,
          {
            entryDate: action.entryDate,
            showPopover: action.show,
            isTag: action.isTag,
            otHours: action.otHours,
            isUnTagging: action.isUnTag,
            entryId: action.entryId,
          },
        ],
      };
    case "SET_OVERTIME_ENTRIES":
      return {
        ...state,
        overTimeEntries: action.overTimeEntries,
      };
    case "SET_DAILY_TASKS_PAGINATION":
      return {
        ...state,
        numItems: action.numItems,
        min: action.min,
        totalPages: action.totalPages,
        currentPage:
          typeof action.currentPage !== "undefined"
            ? action.currentPage
            : state.currentPage,
        max: action.max,
      };
    case "RESET_DAILY_TASKS_PAGINATION":
      return {
        ...state,
        currentPage: 1,
        totalPages: 0,
        numItems: 0,
        min: 1,
        max: MAX_ITEMS_IN_PAGE,
      };
    case "GET_TIME_ENTRIES_PER_PROJECT":
      return {
        ...state,
        timeEntriesPerProject: [
          ...state.timeEntriesPerProject,
          action.timeEntries,
        ],
      };
    case "RESET_TIME_ENTRIES_PER_PROJECT":
      return {
        ...state,
        timeEntriesPerProject: [],
      };
    case "GET_APPROVED_TIME_ENTRIES":
      return {
        ...state,
        approvedTimeEntries: [
          ...state.approvedTimeEntries,
          ...action.timeEntries,
        ],
      };
    case "CLEAR_APPROVED_TIME_ENTRIES":
      return {
        ...state,
        approvedTimeEntries: [],
      };
    case "UPDATE_TARGET_TRANSACTION":
      return {
        ...state,
        taskEntries: state.taskEntries.map((taskEntry) =>
          taskEntry.entry_id === action.entry_id
            ? action.updatedTaskEntry
            : taskEntry
        ),
      };
    default:
      return state;
  }
};

export default taskReducer;
